import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import CategoryManagerMixin from '@/helpers/vue_mixins/v2/CategoryManagerMixin';
import ViewRendererMixin from '@/helpers/vue_mixins/ViewRendererMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseViewManager from '@/components/v2/BaseViewManager.vue';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import ShowSearchBarMixin from '@/helpers/vue_mixins/v2/ShowSearchBarMixin';
/**
 * Category View Manager
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let TheCategoryViewManager = class TheCategoryViewManager extends Mixins(CategoryManagerMixin, OrangeThemeMixin, ViewRendererMixin, ShowSearchBarMixin) {
    get gridView() {
        return () => import('@/components/v2/ecommerce/CategoryGridView.vue');
    }
    get listView() {
        return () => import('@/components/v2/ecommerce/CategoryListView.vue');
    }
};
__decorate([
    Prop({ type: String, required: true })
], TheCategoryViewManager.prototype, "createRoutePath", void 0);
TheCategoryViewManager = __decorate([
    Component({
        components: {
            BaseViewManager,
            PageTitle,
        },
    })
], TheCategoryViewManager);
export default TheCategoryViewManager;
